import React, { Component, PropTypes } from 'react';

export default class OnsiteField extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange() {
    this.props.onChange();
    this.props.updateSettings();
  }

  render() {
    const { shouldShow, id, notification, checked } = this.props;

    if (!shouldShow) {
      return null;
    }

    return (<div className="row">
      <div className="small-16 medium-10 medium-offset-3 column">
        <div className="checkbox">
          <input
            type="checkbox"
            onChange={this.onChange}
            className="form-control"
            id={`onsite-${id}`}
            checked={checked}
          />
          <label htmlFor={`onsite-${id}`} className="form-label">
            { notification.desc }
          </label>
        </div>
      </div>
    </div>);
  }
}

OnsiteField.propTypes = {
  shouldShow: PropTypes.bool,
  checked: PropTypes.bool,
  id: PropTypes.string,
  notification: PropTypes.shape({
    user_type: PropTypes.arrayOf(PropTypes.string),
    desc: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  updateSettings: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./account/components/onsite_field.jsx